export default () => {
  $('.stb-product-item__variants .stb-product-item__variant').click((e) => {
    const _self = $(e.currentTarget)
    const imgUrl = _self.data('img_url')
    const sku = _self.data('sku')

    _self
      .parents('.stb-product-item')
      .find('.attachment-woocommerce_thumbnail')
      .attr('src', imgUrl)
      .attr('srcset', imgUrl)
      
    _self
      .parents('.stb-product-item')
      .find('.stb-product-item__sku')
      .text(sku)
  })
}
